const ApiConfig = {
    Employee: {
        Register: '/api/employee/register/email',
        Login: '/api/employee/login/email',
        GoogleLogin: '/api/employee/login/google',
        GoogleRegister: '/api/employee/register/google',
        ApplyJob: '/api/jobapply'
    },
    JobSearch: {
        title: '/api/jobsearch?title',
        Company: '/api/jobsearch?companyname'
    },
    Employer: {
        Register: '/api/employer/register/email',
        Login: '/api/employer/login/email',
        GoogleLogin: '/api/employer/login/google',
        GoogleRegister: '/api/employer/register/google',
        PostJob: '/api/employer/jobpost'
    },
    Admin: {
        adminlogin: '/api/admin/login',
        jobSeeker: '/api/admin/alljobseeker',
        allEmployer: '/api/admin/allemployer',
        allJobs: '/api/admin/alljobs',
        pricing: {
            setDays: '/api/admin/setdays',
            jobPrice: '/api/jobprice'
        }
    }
}

export default ApiConfig;